export const getBarColor = ({ barColor }) =>
  `background-color: ${barColor || 'black'}`
  